import { Instagram, Facebook, Youtube, MessageCircle } from "lucide-react";
import { waLink } from "@/lib/api";

const TikTok = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.6 5.82A4.28 4.28 0 0 1 15.54 3h-3.09v12.4a2.59 2.59 0 0 1-2.59 2.5 2.6 2.6 0 0 1-2.6-2.6 2.6 2.6 0 0 1 3.35-2.49V9.66a5.73 5.73 0 0 0-.75-.05A5.69 5.69 0 0 0 4.17 15.3 5.69 5.69 0 0 0 9.86 21a5.69 5.69 0 0 0 5.69-5.69V9.01a7.35 7.35 0 0 0 4.3 1.38V7.3a4.3 4.3 0 0 1-3.25-1.48Z" />
  </svg>
);

export function socialLinks(s) {
  if (!s) return [];
  return [
    { key: "instagram", label: "Instagram", url: s.instagram, Icon: Instagram },
    { key: "tiktok", label: "TikTok", url: s.tiktok, Icon: TikTok },
    { key: "whatsapp", label: "WhatsApp", url: waLink(s.whatsapp), Icon: MessageCircle },
    { key: "facebook", label: "Facebook", url: s.facebook, Icon: Facebook },
    { key: "youtube", label: "YouTube", url: s.youtube, Icon: Youtube },
  ].filter((x) => x.url);
}
